import React, { useState } from 'react'
import { Dropdown, MenuProps, Tooltip } from 'antd'
import { bingliIcn, checkBoxEmptyIcn400, checkBoxIcn400, chevronIcn, deleteIcn, downloadIcn, emailIcn, indeterminateCheckBoxIcn400, nextStepIcn, personAddIcn } from '../../../../assets/CustomIcons'
import './index.less'
import { DropdownRow } from '../../../common/DropdownRow'
import { IconButton } from '../../../common/IconButton'
import Icon from '@ant-design/icons'
import { SelectAllUsersStateType } from '../../types'

interface AllUsersActionsPanelProps {
  onSelectAllClick: () => void
  onDeselectAllClick: () => void
  onSendEmailClick: () => void
  onAdvanceWorkflowClick: () => void
  onDeleteAllClick: () => void
  onExportSelected: () => void
  onImportBingli: () => void
  onCreateUserAccountsClick: () => void
  canCreateUserAccounts: boolean
  selectedPatientsState: SelectAllUsersStateType
}

export const AllUsersActionsPanel = ({
  onSelectAllClick,
  onDeselectAllClick,
  onSendEmailClick,
  onAdvanceWorkflowClick,
  onDeleteAllClick,
  onExportSelected,
  onImportBingli,
  onCreateUserAccountsClick,
  canCreateUserAccounts,
  selectedPatientsState,
}: AllUsersActionsPanelProps) => {
  const [isOverFlowMenuOpen, setOverFlowMenuOpen] = useState(false)

  const items: MenuProps['items'] = [
    {
      key: 'select_all',
      label: <DropdownRow icon={checkBoxIcn400} label="Select all patients" />,
    },
    {
      key: 'deselect_all',
      label: <DropdownRow icon={checkBoxEmptyIcn400} label="Deselect all patients" />,
    },
  ]
  const onClick: MenuProps['onClick'] = ({ key }) => {
    switch (key) {
      case 'select_all': {
        onSelectAllClick()
        break
      }
      case 'deselect_all': {
        onDeselectAllClick()
        break
      }
    }
  }
  const getCheckboxMainIcon = () => {
    switch (selectedPatientsState) {
      case 'empty':
        return checkBoxEmptyIcn400
      case 'selectedSome':
        return indeterminateCheckBoxIcn400
      case 'selectedAll':
        return checkBoxIcn400
    }
  }
  const getCLickOnTheDropdown = () => {
    if (selectedPatientsState === 'empty') {
      onSelectAllClick()
    } else {
      onDeselectAllClick()
    }
  }

  return (
    <div className="AllUsersActionsPanel">
      <Dropdown menu={{ items, onClick }} placement="bottomRight" onOpenChange={(open: boolean) => setOverFlowMenuOpen(open)}>
        <div className="AllUsersActionsPanel__dropdown" onClick={getCLickOnTheDropdown}>
          <IconButton isActive={isOverFlowMenuOpen} icon={getCheckboxMainIcon()} />
          <Icon className="AllUsersActionsPanel__dropdown__chevron" component={chevronIcn} />
        </div>
      </Dropdown>
      <div className="AllUsersActionsPanel__divider"></div>
      <div className="AllUsersActionsPanel__actions">
        <Tooltip title="Impot bingli forms" placement="topLeft">
          <div>
            <IconButton onClick={onImportBingli} icon={bingliIcn} />
          </div>
        </Tooltip>
      </div>
      {selectedPatientsState !== 'empty' && (
        <>
          <div className="AllUsersActionsPanel__divider"></div>
          <div className="AllUsersActionsPanel__actions">
            <Tooltip title="Send Bingli link by email to the selected patients" placement="topLeft">
              <div>
                <IconButton onClick={onSendEmailClick} icon={emailIcn} />
              </div>
            </Tooltip>
            <Tooltip
              title={
                canCreateUserAccounts
                  ? 'Create user accounts for selected patients (those with an email and no existing account)'
                  : 'No selected patient is eligible for a new user account'
              }
              placement="topLeft"
            >
              <div>
                <IconButton onClick={canCreateUserAccounts ? onCreateUserAccountsClick : undefined} icon={personAddIcn} />
              </div>
            </Tooltip>
            <Tooltip title="Advance workflow for selected items" placement="topLeft">
              <div>
                <IconButton onClick={onAdvanceWorkflowClick} icon={nextStepIcn} />
              </div>
            </Tooltip>
            <Tooltip title="Delete selected patients" placement="topLeft">
              <div>
                <IconButton onClick={onDeleteAllClick} icon={deleteIcn} />
              </div>
            </Tooltip>
            <Tooltip title="Export selected patients" placement="topLeft">
              <div>
                <IconButton onClick={onExportSelected} icon={downloadIcn} />
              </div>
            </Tooltip>
          </div>
        </>
      )}
    </div>
  )
}
